import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { createContainer } from "./platform/container.ts";
import { installDesktopLinkHandler } from "./platform/desktopLinks.ts";
import { registerServiceWorker } from "./platform/pwa.ts";
import "./shell/shell.css";

const root = createRoot(document.getElementById("root")!);
// Local-only startup (IndexedDB restore); the network is never awaited before first paint.
void createContainer().then((container) => {
  // Dev-only handle for debugging (query cache, view models).
  if (import.meta.env.DEV) (window as unknown as { bundle: unknown }).bundle = container;
  root.render(
    <StrictMode>
      <App container={container} />
    </StrictMode>,
  );
});
registerServiceWorker();
// Desktop app: links to Bundle itself (meetings, workspace URLs) open in the app, not the browser.
installDesktopLinkHandler();
